// Local dependencies
import { ResetError } from '../../../../common/types/reset-error';
import { Logo } from '../../../utils/types';

export enum UpdateCategoryActionTypes {
  UPDATE_CATEGORY = 'UPDATE_CATEGORY',
  UPDATE_CATEGORY_SUCCESS = 'UPDATE_CATEGORY_SUCCESS',
  UPDATE_CATEGORY_ERROR = 'UPDATE_CATEGORY_ERROR',

  CLOSE_UPDATE_CATEGORY_SUCCESS_POPUP = 'CLOSE_UPDATE_CATEGORY_SUCCESS_POPUP',
  RESET_UPDATE_CATEGORY_ERROR = 'RESET_UPDATE_CATEGORY_ERROR',
}

export interface UpdateCategoryState {
  loading: boolean;
  error: Error | null;
  success: boolean;
}

export interface UpdateCategoryInput {
  code: string;
  name_en: string;
  name_ky: string;
  name_ru: string;
  name_tr: string;
  popularityScore: number;
  logo?: Logo;
  tags?: string[];
  rboCode?: string;
}

export interface UpdateCategory {
  type: UpdateCategoryActionTypes.UPDATE_CATEGORY;
  input: UpdateCategoryInput;
}

export interface UpdateCategorySuccess {
  type: UpdateCategoryActionTypes.UPDATE_CATEGORY_SUCCESS;
}

export interface CloseUpdateCategorySuccessPopup {
  type: UpdateCategoryActionTypes.CLOSE_UPDATE_CATEGORY_SUCCESS_POPUP;
}

export interface UpdateCategoryError {
  type: UpdateCategoryActionTypes.UPDATE_CATEGORY_ERROR;
  error: Error;
}

export type UpdateCategoryAction =
  | UpdateCategory
  | UpdateCategorySuccess
  | UpdateCategoryError
  | ResetError<UpdateCategoryActionTypes.RESET_UPDATE_CATEGORY_ERROR>
  | CloseUpdateCategorySuccessPopup;

export type UpdateCategoryLogo = FileList | Logo;
